module.exports = __webpack_public_path__ + "static/media/bctc-logo.e112e190.png";